import { Editor } from '@tiptap/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BubbleMenuButton } from './Button/BubbleMenuButton';
import { ActionType, BubbleMenuConfig } from './bubbleMenu.config';

type Props = {
  editor: Editor;
  selectionType: 'link' | null;
  setSelectionType: (type: 'link' | null) => void;
  onLinkSubmit: (url: string) => void;
};

export const BubbleMenuContent = ({
  editor,
  selectionType,
  setSelectionType,
  onLinkSubmit,
}: Props) => {
  const { t } = useTranslation(['common']);
  const [linkUrl, setLinkUrl] = useState<string>('');
  const config = BubbleMenuConfig(t);

  const handleAction = (action: ActionType) => {
    if (action.type === 'link') {
      if (editor.isActive('link')) {
        const attrs = editor.getAttributes('link');
        setLinkUrl(attrs.href || '');
        setSelectionType('link');
      } else {
        setLinkUrl('');
        setSelectionType('link');
      }
    } else {
      action.execute(editor);
      setSelectionType(null);
    }
  };

  if (selectionType === 'link') {
    return (
      <div className="flex items-center gap-2 px-2 py-1" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          type="text"
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          placeholder={t('paste_link')}
          className="w-40 rounded border border-border bg-transparent px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onLinkSubmit(linkUrl);
            }
            if (event.key === 'Escape') {
              setSelectionType(null);
            }
          }}
        />
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center gap-1 border-r border-border pr-1">
        {config.formatting.map((item) => (
          <BubbleMenuButton
            key={item.label}
            editor={editor}
            action={() => handleAction(item.action)}
            isActive={item.isActive(editor)}
            icon={item.icon}
            label={item.label}
          />
        ))}
      </div>

      <div className="flex items-center gap-1 border-r border-border pr-1">
        {config.lists.map((item) => (
          <BubbleMenuButton
            key={item.label}
            editor={editor}
            action={() => handleAction(item.action)}
            isActive={item.isActive(editor)}
            icon={item.icon}
            label={item.label}
          />
        ))}
      </div>

      <div className="flex items-center gap-1 pl-1">
        {config.links.map((item) => (
          <BubbleMenuButton
            key={item.label}
            editor={editor}
            action={() => handleAction(item.action)}
            isActive={item.isActive(editor)}
            icon={item.icon}
            label={item.label}
          />
        ))}
      </div>
    </>
  );
};
